export type AuthProviderName = "clerk" | "auth0";

export const CLERK_AUTH_BASE_PATH = "/clerk";

const configuredProvider = import.meta.env.VITE_AUTH_PROVIDER;

export const authProviderName: AuthProviderName =
  configuredProvider === "clerk"
    ? configuredProvider
    : "auth0";

export const isAuth0Enabled = authProviderName === "auth0";

export function isClerkAuthPath(pathname: string): boolean {
  return pathname === CLERK_AUTH_BASE_PATH || pathname.startsWith(`${CLERK_AUTH_BASE_PATH}/`);
}

export function authProviderNameForPath(pathname: string): AuthProviderName {
  if (isClerkAuthPath(pathname)) return "clerk";
  return authProviderName;
}

export function authRoutePrefixForPath(pathname: string): string {
  return isClerkAuthPath(pathname) ? CLERK_AUTH_BASE_PATH : "";
}

export function withAuthRoutePrefix(path: string, pathname: string): string {
  const prefix = authRoutePrefixForPath(pathname);
  if (!prefix) return path;
  if (path === "/") return prefix;
  return `${prefix}${path}`;
}
